var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Migas-estadisticas"},_vm._l((_vm.migas),function(item,index){return _c('p',[(index)?_c('span',[_vm._v(">")]):_vm._e(),_c('strong',[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }